/**
 * @generated SignedSource<<6e87a7fa2cb2d2ed1db57ea380719775>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type storyCardCarouselWidgetQuery$variables = {};
export type storyCardCarouselWidgetQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersStoryStyleArticleListQuery">;
};
export type storyCardCarouselWidgetQuery = {
  response: storyCardCarouselWidgetQuery$data;
  variables: storyCardCarouselWidgetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "1070"
    }
  }
],
v1 = {
  "kind": "Literal",
  "name": "exclude",
  "value": {
    "types": "VIDEO"
  }
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = [
  {
    "alias": "items",
    "args": [
      (v1/*: any*/)
    ],
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "__helpersStoryStyleArticleListQuery__items_connection",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "QueueItemsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "storyStyleCardArticle"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "storyCardCarouselItemArticle"
                  }
                ],
                "type": "Article",
                "abstractKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      (v5/*: any*/)
    ],
    "storageKey": "__helpersStoryStyleArticleListQuery__items_connection(exclude:{\"types\":\"VIDEO\"})"
  }
],
v7 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_516294"
    }
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_516298"
    }
  }
],
v9 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_516301"
    }
  }
],
v10 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_516305"
    }
  }
],
v11 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  }
],
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = [
  (v3/*: any*/),
  (v13/*: any*/)
],
v15 = [
  (v13/*: any*/)
],
v16 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "type": {
                        "exclude": null
                      }
                    }
                  }
                ],
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "images",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "alt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSlideshow",
                    "storageKey": null
                  },
                  {
                    "alias": "url",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "style": "portrait"
                        }
                      }
                    ],
                    "concreteType": "ImageStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": "style(filter:{\"style\":\"portrait\"})"
                  },
                  {
                    "alias": "resized",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "style": "134w_portrait"
                        }
                      }
                    ],
                    "concreteType": "ImageStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": "style(filter:{\"style\":\"134w_portrait\"})"
                  }
                ],
                "storageKey": "images(filter:{\"type\":{\"exclude\":null}})"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "socialHeadline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlAlias",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publishedDate",
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entityUuid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UrlRedirect",
                    "kind": "LinkedField",
                    "name": "urlRedirect",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "toUrl",
                        "storageKey": null
                      },
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Application",
                    "kind": "LinkedField",
                    "name": "application",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Section",
                        "kind": "LinkedField",
                        "name": "fullSectionPath",
                        "plural": true,
                        "selections": (v14/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "Section",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SectionSegment",
                        "kind": "LinkedField",
                        "name": "sections",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Section",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": (v14/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "articleTypes",
                        "args": null,
                        "concreteType": "ArticleTypeSegment",
                        "kind": "LinkedField",
                        "name": "types",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ArticleType",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": (v14/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sponsorType",
                        "storageKey": null
                      }
                    ],
                    "type": "Article",
                    "abstractKey": null
                  }
                ],
                "type": "Base",
                "abstractKey": "__isBase"
              }
            ],
            "type": "Article",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v15/*: any*/),
            "type": "Node",
            "abstractKey": "__isNode"
          },
          {
            "kind": "InlineFragment",
            "selections": (v15/*: any*/),
            "type": "Gallery",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v15/*: any*/),
            "type": "Podcast",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v15/*: any*/),
            "type": "Recipe",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v15/*: any*/),
            "type": "Video",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v4/*: any*/)
    ],
    "storageKey": null
  },
  (v5/*: any*/)
],
v17 = [
  "exclude"
],
v18 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 8
  }
],
v19 = [
  {
    "alias": null,
    "args": (v18/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v16/*: any*/),
    "storageKey": "items(exclude:{\"types\":\"VIDEO\"},first:8)"
  },
  {
    "alias": null,
    "args": (v18/*: any*/),
    "filters": (v17/*: any*/),
    "handle": "connection",
    "key": "helpersStoryStyleArticleListQuery__items",
    "kind": "LinkedHandle",
    "name": "items"
  },
  (v13/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "storyCardCarouselWidgetQuery",
    "selections": [
      {
        "kind": "InlineDataFragmentSpread",
        "name": "helpersStoryStyleArticleListQuery",
        "selections": [
          {
            "alias": "luxury",
            "args": (v0/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": "queue(filter:{\"entityId\":\"1070\"})"
          },
          {
            "alias": "fashion",
            "args": (v7/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_516294\"})"
          },
          {
            "alias": "beauty",
            "args": (v8/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_516298\"})"
          },
          {
            "alias": "people",
            "args": (v9/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_516301\"})"
          },
          {
            "alias": "lifestyle",
            "args": (v10/*: any*/),
            "concreteType": "Queue",
            "kind": "LinkedField",
            "name": "queue",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": "queue(filter:{\"name\":\"section_top_516305\"})"
          }
        ],
        "args": null,
        "argumentDefinitions": []
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "storyCardCarouselWidgetQuery",
    "selections": [
      {
        "alias": "luxury",
        "args": (v0/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": "items(exclude:{\"types\":\"VIDEO\"},first:4)"
          },
          {
            "alias": null,
            "args": (v11/*: any*/),
            "filters": (v17/*: any*/),
            "handle": "connection",
            "key": "helpersStoryStyleArticleListQuery__items",
            "kind": "LinkedHandle",
            "name": "items"
          },
          (v13/*: any*/)
        ],
        "storageKey": "queue(filter:{\"entityId\":\"1070\"})"
      },
      {
        "alias": "fashion",
        "args": (v7/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v19/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_516294\"})"
      },
      {
        "alias": "beauty",
        "args": (v8/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v19/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_516298\"})"
      },
      {
        "alias": "people",
        "args": (v9/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v19/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_516301\"})"
      },
      {
        "alias": "lifestyle",
        "args": (v10/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v19/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_516305\"})"
      }
    ]
  },
  "params": {
    "cacheID": "ce4e8358a9c22729475b27d2ba962866",
    "id": null,
    "metadata": {},
    "name": "storyCardCarouselWidgetQuery",
    "operationKind": "query",
    "text": "query storyCardCarouselWidgetQuery {\n  ...helpersStoryStyleArticleListQuery\n}\n\nfragment entityLink on Base {\n  __isBase: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n  }\n  ...helpersAppBarVariantArticle\n  ...helpersAppBarAdStatusBase\n}\n\nfragment helpersAppBarAdStatusBase on Base {\n  __isBase: __typename\n  ... on Section {\n    __typename\n    ...helpersStyleSectionContent\n  }\n}\n\nfragment helpersAppBarVariantArticle on Base {\n  __isBase: __typename\n  ...helpersCheckIsPostiesArticle\n  ...helpersCheckIsLongReadArticle\n  ...helpersCheckIsMorningStudioArticle\n  ...helpersCheckIsPhotoEssayArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersStyleSectionContent\n  ...helpersCheckIsPostiesPage\n}\n\nfragment helpersCheckIsLongReadArticle on Article {\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsMorningStudioArticle on Article {\n  sponsorType\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPhotoEssayArticle on Article {\n  articleTypes: types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPostiesArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPostiesPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsStyleArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersStoryStyleArticleListQuery on Query {\n  luxury: queue(filter: {entityId: \"1070\"}) {\n    items(first: 4, exclude: {types: VIDEO}) {\n      __typename\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...storyStyleCardArticle\n            ...storyCardCarouselItemArticle\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on Gallery {\n            id\n          }\n          ... on Podcast {\n            id\n          }\n          ... on Recipe {\n            id\n          }\n          ... on Video {\n            id\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  fashion: queue(filter: {name: \"section_top_516294\"}) {\n    items(first: 8, exclude: {types: VIDEO}) {\n      __typename\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...storyStyleCardArticle\n            ...storyCardCarouselItemArticle\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on Gallery {\n            id\n          }\n          ... on Podcast {\n            id\n          }\n          ... on Recipe {\n            id\n          }\n          ... on Video {\n            id\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  beauty: queue(filter: {name: \"section_top_516298\"}) {\n    items(first: 8, exclude: {types: VIDEO}) {\n      __typename\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...storyStyleCardArticle\n            ...storyCardCarouselItemArticle\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on Gallery {\n            id\n          }\n          ... on Podcast {\n            id\n          }\n          ... on Recipe {\n            id\n          }\n          ... on Video {\n            id\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  people: queue(filter: {name: \"section_top_516301\"}) {\n    items(first: 8, exclude: {types: VIDEO}) {\n      __typename\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...storyStyleCardArticle\n            ...storyCardCarouselItemArticle\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on Gallery {\n            id\n          }\n          ... on Podcast {\n            id\n          }\n          ... on Recipe {\n            id\n          }\n          ... on Video {\n            id\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  lifestyle: queue(filter: {name: \"section_top_516305\"}) {\n    items(first: 8, exclude: {types: VIDEO}) {\n      __typename\n      edges {\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...storyStyleCardArticle\n            ...storyCardCarouselItemArticle\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n          ... on Gallery {\n            id\n          }\n          ... on Podcast {\n            id\n          }\n          ... on Recipe {\n            id\n          }\n          ... on Video {\n            id\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment imageStoryStyleCardImageArticle on Article {\n  images(filter: {type: {exclude: null}}) {\n    alt\n    isSlideshow\n    url: style(filter: {style: \"portrait\"}) {\n      url\n    }\n  }\n}\n\nfragment linkStoryStyleCardLinkArticle on Article {\n  ...entityLink\n  urlAlias\n}\n\nfragment storyCardCarouselItemArticle on Article {\n  publishedDate\n  images(filter: {type: {exclude: null}}) {\n    alt\n    isSlideshow\n    resized: style(filter: {style: \"134w_portrait\"}) {\n      url\n    }\n  }\n  ...entityLink\n}\n\nfragment storyStyleCardArticle on Article {\n  ...imageStoryStyleCardImageArticle\n  ...titleStoryStyleCardTitleArticle\n  ...linkStoryStyleCardLinkArticle\n}\n\nfragment titleStoryStyleCardTitleArticle on Article {\n  socialHeadline\n}\n"
  }
};
})();

(node as any).hash = "32453e20273a0556bded215ab69ccb30";

export default node;
